import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-zinc-400/25 backdrop-blur-sm dark:bg-black/40 opacity-100" }, null, -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-800 bg-opacity-25 transition-opacity" }, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "fixed inset-0 overflow-y-auto px-4 py-4 sm:py-20 sm:px-6 md:py-32 lg:px-8 lg:py-[15vh]" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = {
  key: 0,
  class: "mt-2 mb-4 text-xs font-semibold text-gray-500"
}
const _hoisted_6 = {
  hold: "",
  class: "border-t empty:hidden border-zinc-900 bg-black"
}
const _hoisted_7 = {
  class: /*#__PURE__*/_normalizeClass([
											'group block cursor-default px-4 py-3 bg-zinc-900 border-t border-zinc-800',
										]),
  role: "option"
}
const _hoisted_8 = { class: "mt-1 truncate whitespace-nowrap text-2xs text-zinc-500 text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MagnifyingGlassIcon = _resolveComponent("MagnifyingGlassIcon")!
  const _component_ArrowPathIcon = _resolveComponent("ArrowPathIcon")!
  const _component_SearchComboBoxHack = _resolveComponent("SearchComboBoxHack")!
  const _component_ComboboxInput = _resolveComponent("ComboboxInput")!
  const _component_ComboboxOption = _resolveComponent("ComboboxOption")!
  const _component_ComboboxOptions = _resolveComponent("ComboboxOptions")!
  const _component_Combobox = _resolveComponent("Combobox")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    as: "div",
    open: true,
    class: "relative z-50 search-combobox-container",
    onClose: _ctx.close
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DialogPanel, { class: "mx-auto overflow-hidden rounded-lg bg-zinc-50 shadow-xl ring-1 ring-zinc-900/7.5 dark:bg-zinc-900 dark:ring-zinc-800 sm:max-w-xl opacity-100 scale-100" }, {
          default: _withCtx(() => [
            _createVNode(_component_Combobox, { "onUpdate:modelValue": _ctx.onSelect }, {
              default: _withCtx(({activeOption, activeIndex}) => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_MagnifyingGlassIcon, {
                    class: "pointer-events-none absolute top-3.5 left-4 h-5 w-5 text-gray-400",
                    "aria-hidden": "true"
                  }),
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_ArrowPathIcon, {
                        key: 0,
                        class: "animate-spin inline pointer-events-none absolute top-3.5 right-4 h-5 w-5 text-gray-400"
                      }))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(), _createBlock(_component_SearchComboBoxHack, {
                    index: activeIndex,
                    key: activeIndex,
                    onChange: _ctx.onIndexChange
                  }, null, 8 /* PROPS */, ["index", "onChange"])),
                  _createVNode(_component_ComboboxInput, {
                    class: "h-12 w-full border-0 bg-black pl-11 pr-4 text-gray-200 placeholder-gray-400 focus:ring-0 sm:text-sm",
                    placeholder: "Search The Docs...",
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateQuery($event.target.value))),
                    onKeydown: _ctx.onKeydown
                  }, null, 8 /* PROPS */, ["onKeydown"])
                ]),
                (_ctx.searchDocuments.length > 0)
                  ? (_openBlock(), _createBlock(_component_ComboboxOptions, {
                      key: 0,
                      class: "flex divide-x divide-gray-900",
                      as: "div",
                      static: "",
                      hold: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass([
								'h-full min-w-0 flex-auto scroll-py-4 overflow-y-auto',
								activeOption && 'sm:h-full',
							])
                        }, [
                          (_ctx.query === '')
                            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, " Recent searches "))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchDocuments, (document) => {
                              return (_openBlock(), _createBlock(_component_ComboboxOption, {
                                key: document.id,
                                value: document,
                                as: "ul"
                              }, {
                                default: _withCtx(({active}) => [
                                  _createElementVNode("li", _hoisted_7, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["", [
												'text-sm font-medium',
												active ? 'text-emerald-500' : 'text-zinc-100',
											]])
                                    }, _toDisplayString(document.title), 3 /* TEXT, CLASS */),
                                    _createElementVNode("div", _hoisted_8, [
                                      _createElementVNode("span", null, _toDisplayString(document.content.slice(0, 50) + '...'), 1 /* TEXT */)
                                    ])
                                  ])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ], 2 /* CLASS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onUpdate:modelValue"])
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClose"]))
}